import { useNavigate } from "react-router-dom";
import clienteAxios from "../config/clienteAxios";
import toast from "react-hot-toast";

const useLogin = (initialState) => {
  const navigate = useNavigate();

  const handleSubmit = async (event, values, route, roles) => {
    event.preventDefault();
    try {
      const requestData = { ...values, roles };
      const { data } = await clienteAxios.post("/auth", requestData);

      localStorage.setItem("Usuario", JSON.stringify(data));
      navigate(`${route}`);
    } catch (error) {
      toast.error(error.response.data.error);
    }
  };

  return {
    handleSubmit,
  };
};

export default useLogin;
